module.exports = __webpack_public_path__ + "static/media/validation-icon.65b00f05.svg";